import { BASEURL } from "../BaseUrl";

/**
 * Fetches all ViCell fields available in the Voyager service.
 * @param {Object} axios - The Axios instance to use for the request.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getViCellFields = async (axios) => {
  return await axios.get(`${BASEURL}/voyager/vi-cell/all-fields`, {});
};

/**
 * Fetches the transformation rules from the Voyager service.
 * @param {Object} axios - The Axios instance to use for the request.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getTransformationRules = async (axios) => {
  return await axios.get(`${BASEURL}/voyager/transformation-rules`, {});
};

/**
 * Fetches schema entries for a specific user.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {string} user_id - The ID of the user whose schema entries are to be fetched.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getSchemaEntries = async (axios, user_id) => {
  return await axios.get(`${BASEURL}/voyager/get-schema-entry`, {
    params: { user_id },
  });
};

/**
 * Creates a new entry with the provided data in the Voyager service.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {Object} data - The data for the new entry to be created.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const createEntryApi = async (axios, data) => {
  return await axios.post(`${BASEURL}/voyager/add-entry`, data, {});
};

/**
 * Fetches all ViCell entries from the Voyager service.
 * @param {Object} axios - The Axios instance to use for the request.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getViCellEntries = async (axios) => {
  return await axios.get(`${BASEURL}/voyager/get-entries`, {});
};

/**
 * Fetches data for a specific ViCell entry by its ID.
 * @param {Object} axios - The Axios instance to use for the request.
 * @param {string} entry_id - The ID of the ViCell entry to fetch data for.
 * @returns {Promise} - A Promise that resolves with the response from the API.
 */
const getViCellEntriesData = async (axios, entry_id) => {
  return await axios.get(`${BASEURL}/voyager/get-entry-data`, {
    params: { entry_id },
  });
};

export const VoyagerCellApi = {
  getViCellFields,
  getTransformationRules,
  getSchemaEntries,
  createEntryApi,
  getViCellEntries,
  getViCellEntriesData,
};
